import { useMutation } from "@tanstack/react-query";
import authService from "..";
import { SendOtpCodePayload } from "../type";

function useLoginByOtpCode() {
  return useMutation({
    mutationFn: (command: SendOtpCodePayload) => {
      return authService.loginWithOtpCode(command);
    },
  });
}

export default useLoginByOtpCode;
